/**
 * @generated SignedSource<<43c3bd78a15bfc220ab913f0e61745fe>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type EnrollPreviewInput = {
  clientMutationId?: string | null | undefined;
  programId: string;
  startDate: string;
};
export type PreviewProgramStartDateDialogMutation$variables = {
  input: EnrollPreviewInput;
};
export type PreviewProgramStartDateDialogMutation$data = {
  readonly enrollPreview: {
    readonly clientMutationId: string | null | undefined;
    readonly enrollment: {
      readonly id: string;
    };
  } | null | undefined;
};
export type PreviewProgramStartDateDialogMutation = {
  response: PreviewProgramStartDateDialogMutation$data;
  variables: PreviewProgramStartDateDialogMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "EnrollPreviewPayload",
    "kind": "LinkedField",
    "name": "enrollPreview",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Enrollment",
        "kind": "LinkedField",
        "name": "enrollment",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PreviewProgramStartDateDialogMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PreviewProgramStartDateDialogMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "9f8d875a1d19d6273b0a6a9445dffa80",
    "id": null,
    "metadata": {},
    "name": "PreviewProgramStartDateDialogMutation",
    "operationKind": "mutation",
    "text": "mutation PreviewProgramStartDateDialogMutation(\n  $input: EnrollPreviewInput!\n) {\n  enrollPreview(input: $input) {\n    clientMutationId\n    enrollment {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "cf002f25ffca0409173b0829bbdaeec9";

export default node;
